import { NgModule } from '@angular/core';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { EEnvTypes } from '@common/enums/env-types.enum';
import { environment } from '@web-env/environment';

import { AppStoreModule as AppFeatureStoreModule } from './app/app-store.module';
import { WebsiteStoreModule } from './website/website-store.module';
import { LayoutStoreModule } from './layout/layout-store.module';
import { UserStoreModule } from './user/user-store.module';
import { RouterStoreModule } from './router/router-store.module';
import { LibraryBlocksStoreModule } from './library-blocks/library-blocks-store.module';
import { CredentialsStoreModule } from './credentials/credentials-store.module';
import { CollectionsStoreModule } from './collections/collections-store.module';
import { PageStructureStoreModule } from './page-structure/page-structure-store.module';
import { ModalsStoreModule } from './modals/modals-store.module';
import { HistoryStoreModule } from './history/history-store.module';
import { RbacPermissionsStoreModule } from './rbac-permissions/rbac-permissions-store.module';
import { ShopCartIconModule } from './shop-cart-icon/shop-cart-icon.module';
import { LogStoreModule } from './log/log-store.module';

const onlyDevModules = [];

if (environment.type !== EEnvTypes.PROD) {
    onlyDevModules.push(StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }));
}

@NgModule({
    imports: [
        StoreModule.forRoot({}),
        EffectsModule.forRoot([]),
        ...onlyDevModules,
        AppFeatureStoreModule,
        WebsiteStoreModule,
        LayoutStoreModule,
        UserStoreModule,
        RouterStoreModule,
        LibraryBlocksStoreModule,
        CredentialsStoreModule,
        CollectionsStoreModule,
        PageStructureStoreModule,
        ModalsStoreModule,
        HistoryStoreModule,
        RbacPermissionsStoreModule,
        ShopCartIconModule,
        LogStoreModule,
    ],
})
export class AppStoreModule {}
